import { useState } from "react";
import { guFaqs } from "@/mocks/faqs";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.6fr]">
          <div>
            <span className="text-xs font-bold tracking-[0.25em] text-primary-600">FAQ</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              吃瓜之前，先搞清楚这几件事
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于内容来源、评论统计和我们的立场，都在这里说清楚。如果还有疑问，欢迎发邮件问我们。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-secondary-50 p-5">
              <p className="flex items-center gap-2 text-sm font-bold text-secondary-900">
                <i className="ri-information-line text-lg" />
                理性吃瓜提示
              </p>
              <p className="mt-2 text-sm leading-relaxed text-secondary-900/80">
                评论区观点只代表网友个人，不代表事实全貌。看瓜可以，别替任何人下结论，也别去别人评论区刷屏。
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {guFaqs.map((faq, index) => {
              const isOpen = open === index;
              return (
                <div
                  key={faq.question}
                  className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="text-sm font-bold text-foreground-950 md:text-base">
                        {faq.question}
                      </span>
                      <i
                        className={`shrink-0 text-xl text-primary-600 transition-transform ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                      />
                    </button>
                  </h3>
                  {isOpen && (
                    <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                      {faq.answer}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}